var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"title":"Edit Order Type","inputs-map":_vm.form,"save-cb":_vm.saveOrderType,"reset-inputs":_vm.resetOrderType}})
}
var staticRenderFns = []

export { render, staticRenderFns }